<template>
    <div class="info">
        <div>
            <div>用户资料</div>
            <div>
                <i @click="edit" class="el-icon-edit-outline"></i>
            </div>
        </div>
        <div>
            <div>头像</div>
            <div>
                <i v-if="!info.avatar" class="el-icon-user-solid"></i>
                <img v-else :src="$store.state.imgUrl+info.avatar">
            </div>
        </div>
        <div>
            <div>昵称</div>
            <div>{{$store.state.nickname}}</div>
        </div>
        <div>
            <div>账号</div>
            <div>{{phone}}</div>
            <div></div>
        </div>
        <div>
            <div>姓名</div>
            <div>{{info.name}}</div>
        </div>
        <div>
            <div>公司名称</div>
            <div>{{info.isNotCertified=='2'?info.companyName:'未认证'}}</div>
        </div>
        <div style="padding-bottom: 30px;">
            <el-button style="float: left;" label-position="left" type="danger" @click="outLogin">退出登录</el-button>
        </div>

        <el-dialog title="编辑资料" :visible.sync="dialogVisible" width="30%">
            <div style="text-align: left; height: 80px;">
                <el-form ref="form" label-width="80px">
                    <el-form-item label="姓名">
                        <el-input v-model="name"></el-input>
                    </el-form-item>
                    <el-form-item label="公司名称" v-if="info.isNotCertified!='2'">
                        <el-input v-model="companyName"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="danger" @click="onSubmit">提交</el-button>
                        <el-button @click="dialogVisible = false">取消</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: "Info",
        data() {
            return {
                dialogVisible: false,
                phone: null,
                info: {
                    isNotCertified: null
                },

                companyName: '',
                name: '',
            }
        },
        created() {
            this.phone = sessionStorage.getItem('phone');
            this.getUser();
        },
        methods: {
            onSubmit() {
                let that = this;
                let params = {
                    telnum: sessionStorage.getItem('phone'),
                    name: that.name
                }
                this.request({
                    method: 'post',
                    url: this.$store.state.httpUrl + "mobileInterf/saveUser",
                    params
                }).then(res => {
                    if (res.status == '200') {
                        that.getUser();
                        this.$message.success(res.msg);
                    }else{
                        this.$message.error(res.msg);
                    }
                })
            },
            edit() {
                this.dialogVisible = true;
            },
            outLogin() {
                this.$store.state.isLogin = 0;
                this.$store.state.userId = '';
                this.$store.state.businessNo = '';
                sessionStorage.clear();
                this.goRouter('/login');
            },
            getUser() {
                let that = this;
                this.request.get(this.$store.state.httpUrl + "userDetails/findUserPerson", {
                    params: {
                        id: this.$store.state.userId,
						flag: this.$store.state.isPerson
                    }
                }).then(res => {
                    if (res.status == 200) {
                        this.info = res.data;
                        sessionStorage.setItem("isLogin", "1");
                        sessionStorage.setItem("isMain", 1);

                        sessionStorage.setItem("isNotCertified", res.data.isNotCertified); //认证字段
                        sessionStorage.setItem("isNotCertifiedPerson", res.data.isNotCertifiedPerson); //认证字段
                        that.$store.state.isNotCertified = res.data.isNotCertified;
                        that.$store.state.isNotCertifiedPerson = res.data.isNotCertifiedPerson;

                        sessionStorage.setItem("state", JSON.stringify(that.$store.state));

                        sessionStorage.setItem("userId", res.data.userId);
                        sessionStorage.setItem("nickname", res.data.nickname);
						
                        that.$store.state.userId = sessionStorage.getItem('userId');
                        that.$store.state.nickname = sessionStorage.getItem('nickname');
                        that.$store.state.telNum = sessionStorage.getItem('phone');
                        that.$store.state.businessNo = sessionStorage.getItem('organizationId');
                        that.$store.state.isNotCertified = sessionStorage.getItem('isNotCertified');
                        that.$store.state.isNotCertifiedPerson = sessionStorage.getItem('isNotCertifiedPerson');
                        that.$store.state.companyName = sessionStorage.getItem('companyNameUser');
                    }
                });
            }
        }
    };
</script>

<style scoped>
    .info {
        padding: 0 24px;
    }

    .info>div {
        display: flex;
        margin-top: 30px;
    }

    .info>div>div:nth-child(1) {
        width: 80px;
        font-size: 18px;
        color: #999999;
        text-align: left;
    }

    .info>div>div:nth-child(2) {
        font-size: 18px;
        color: #333333;
        margin-left: 24px;
    }

    .info>div:nth-child(1) {
        display: flex;
        justify-content: space-between;
    }

    .info>div:nth-child(1)>div:nth-child(1) {
        color: #333333;
    }

    .info>div:nth-child(1)>div:nth-child(2) {
        color: #D70606;
    }

    .info>div:nth-child(2) {
        line-height: 100px;
    }

    .info>div:nth-child(2)>div:nth-child(2) {
        width: 100px;
        height: 100px;
        border-radius: 50%;
        text-align: center;
        line-height: 100px;
        color: #FFFFFF;
        background: #E7E7E7;
        font-size: 50px;
    }

    .info>div:nth-child(2)>div:nth-child(2)>img {
        width: 100px;
        height: 100px;
        border-radius: 50%;
    }

    .info>div:nth-child(4) {
        padding-bottom: 18px;
        border-bottom: 1px solid #E7E7E7;
    }

    .info>div:nth-child(4)>div:nth-child(3) {
        font-size: 18px;
        color: #D70606;
        margin-left: 40px;
    }

    .info>div:nth-child(5) {
        margin-top: 24px;
    }
</style>



// WEBPACK FOOTER //
// src/view/me/info.vue